var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _g5, _path0, _path1, _g6, _path10, _path11, _path12, _path13, _g7, _path14, _path15, _g8, _path16, _path17, _path18, _g9, _path19, _g0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPikko(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 47,
    viewBox: "0 0 35 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.26289 14.1598C2.26289 14.1598 14.8173 13.3111 14.9028 26.6292C1.40417 26.5447 2.26289 14.1598 2.26289 14.1598Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16471_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 13,
    width: 15,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.48535 13.0874H15.9087V27.4693H1.48535V13.0874Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16471_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6344 27.3571L14.8962 27.3532C10.5423 27.3244 7.15603 26.059 4.83049 23.5859C1.18967 19.7168 1.518 14.3404 1.53355 14.1138L1.57629 13.4897L2.21159 13.4456C2.21159 13.4456 2.39032 13.4321 2.70506 13.4321C4.84992 13.4321 15.5489 14.0696 15.6305 26.6274L15.6344 27.3571Z",
    fill: "url(#paint0_linear_16471_521)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_16471_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 0,
    width: 12,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9287 0.00146484H22.3732V19.9691H11.9287V0.00146484Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_16471_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2134 19.7149L16.6946 19.1965C13.6347 16.1396 12.1485 12.8811 12.2767 9.51127C12.4768 4.2347 16.5606 0.663223 16.7354 0.515371L17.2134 0.102539L17.6932 0.515371C17.8681 0.663223 21.9519 4.2347 22.152 9.51127C22.2802 12.8811 20.7939 16.1396 17.734 19.1965L17.2134 19.7149Z",
    fill: "url(#paint1_linear_16471_521)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5212 14.1598C32.5212 14.1598 19.9688 13.3111 19.8813 26.6292C33.3819 26.5447 32.5212 14.1598 32.5212 14.1598Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_16471_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 13,
    width: 16,
    height: 15
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8931 13.0874H33.3165V27.4693H18.8931V13.0874Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_16471_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.147 27.3571L19.1528 26.6274C19.2344 14.0696 29.9334 13.4321 32.0763 13.4321C32.393 13.4321 32.5718 13.4456 32.5718 13.4456L33.2051 13.4897L33.2498 14.1138C33.2653 14.3404 33.5937 19.7149 29.9529 23.5859C27.6293 26.059 24.241 27.3244 19.8852 27.3532L19.147 27.3571Z",
    fill: "url(#paint2_linear_16471_521)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_16471_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 21,
    width: 35,
    height: 39
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.487305 21.2627H34.3077V59.731H0.487305V21.2627Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_16471_521)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_16471_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 21,
    width: 34,
    height: 39
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4657 59.7348V21.2972C23.3511 21.2896 23.2384 21.2896 23.1238 21.2896H11.6846V59.7348H23.4657ZM8.75287 59.7348H11.6846V21.2972H11.6205C6.88001 21.2972 2.71852 25.1202 2.37658 29.7881L0.773769 51.2535C0.422122 55.9118 4.01437 59.7348 8.75287 59.7348ZM25.9894 59.7348C30.7299 59.7348 34.3202 55.9118 33.9705 51.2439L32.3657 29.7805C32.0238 25.2259 28.0508 21.4758 23.458 21.2972V59.7348H25.9894Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_16471_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9949 59.7354H0.772949V21.2671H33.9949V59.7354Z",
    fill: "url(#paint3_linear_16471_521)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_16471_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 20,
    width: 16,
    height: 16
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.2925H15.1422V35.2581H0V20.2925Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_16471_521)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_16471_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 20,
    width: 16,
    height: 16
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57112 20.2939C3.3902 20.2939 0 23.6427 0 27.7768C0 31.9089 3.3902 35.2596 7.57112 35.2596C11.752 35.2596 15.1422 31.9089 15.1422 27.7768C15.1422 23.6427 11.752 20.2939 7.57112 20.2939Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_16471_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20.2939H15.1422V35.2596H0V20.2939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20.2939H15.1422V35.2596H0V20.2939Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_16471_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 20,
    width: 11,
    height: 11
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94141 20.7681H13.3834V30.1019H3.94141V20.7681Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_16471_521)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_16471_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 20,
    width: 11,
    height: 11
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66438 20.7695C6.05713 20.7695 3.94336 22.8587 3.94336 25.4374C3.94336 28.0143 6.05713 30.1034 8.66438 30.1034C11.2716 30.1034 13.3854 28.0143 13.3854 25.4374C13.3854 22.8587 11.2716 20.7695 8.66438 20.7695Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_16471_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.94336 20.7695H13.3854V30.1034H3.94336V20.7695Z",
    fill: "#3D1F1E"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6781 27.505C8.6781 26.3818 9.52529 25.5722 10.637 25.5722C9.57696 25.5722 8.679 24.7098 8.679 23.6386C8.679 24.6996 7.84098 25.5722 6.71924 25.5722C7.84098 25.5722 8.6781 26.4226 8.6781 27.505Z",
    fill: "url(#paint4_linear_16471_521)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6781 23.6377L8.679 23.6386M8.679 23.6386C8.679 24.7098 9.57696 25.5722 10.637 25.5722C9.52529 25.5722 8.6781 26.3818 8.6781 27.505C8.6781 26.4226 7.84098 25.5722 6.71924 25.5722C7.84098 25.5722 8.679 24.6996 8.679 23.6386Z",
    stroke: "url(#paint5_linear_16471_521)",
    strokeWidth: 1.45448,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_16471_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 20,
    width: 16,
    height: 16
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1738 20.2925H33.3161V35.2581H18.1738V20.2925Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_16471_521)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_16471_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 20,
    width: 16,
    height: 16
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.744 20.2939C21.563 20.2939 18.1729 23.6427 18.1729 27.7768C18.1729 31.9089 21.563 35.2596 25.744 35.2596C29.9249 35.2596 33.3151 31.9089 33.3151 27.7768C33.3151 23.6427 29.9249 20.2939 25.744 20.2939Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_16471_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1729 20.2939H33.3151V35.2596H18.1729V20.2939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1729 20.2939H33.3151V35.2596H18.1729V20.2939Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_16471_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 20,
    width: 10,
    height: 11
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 20.7686H31.567V30.1024H22.125V20.7686Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_16471_521)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_16471_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 20,
    width: 10,
    height: 11
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.848 20.77C24.2407 20.77 22.127 22.8591 22.127 25.4379C22.127 28.0147 24.2407 30.1039 26.848 30.1039C29.4552 30.1039 31.569 28.0147 31.569 25.4379C31.569 22.8591 29.4552 20.77 26.848 20.77Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_16471_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.127 20.77H31.569V30.1039H22.127V20.77Z",
    fill: "#3D1F1E"
  })))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8617 27.505C26.8617 26.3818 27.7089 25.5722 28.8205 25.5722C27.7606 25.5722 26.8626 24.7098 26.8626 23.6386C26.8626 24.6996 26.0246 25.5722 24.9028 25.5722C26.0246 25.5722 26.8617 26.4226 26.8617 27.505Z",
    fill: "url(#paint6_linear_16471_521)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8617 23.6377L26.8626 23.6386M26.8626 23.6386C26.8626 24.7098 27.7606 25.5722 28.8205 25.5722C27.7089 25.5722 26.8617 26.3818 26.8617 27.505C26.8617 26.4226 26.0246 25.5722 24.9028 25.5722C26.0246 25.5722 26.8626 24.6996 26.8626 23.6386Z",
    stroke: "url(#paint7_linear_16471_521)",
    strokeWidth: 1.45448,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_16471_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 39,
    width: 11,
    height: 11
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0825 39.854H22.7951V49.2471H12.0825V39.854Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_16471_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4374 51.7071C17.0858 51.7071 16.738 51.6696 16.3941 51.5931C16.0483 51.518 15.7141 51.4054 15.3897 51.2569C15.0652 51.1068 14.7563 50.9251 14.4649 50.709C14.1715 50.4929 13.9015 50.2467 13.6528 49.972C13.4041 49.6958 13.1827 49.3972 12.9884 49.0729C12.7922 48.7502 12.627 48.408 12.493 48.0478C12.3589 47.6891 12.2579 47.3183 12.1879 46.9371C12.1199 46.5543 12.0869 46.1701 12.0869 45.7798C12.0869 45.3911 12.1199 45.0053 12.1879 44.6241C12.2579 44.2428 12.3589 43.8721 12.493 43.5119C12.627 43.1531 12.7922 42.8109 12.9884 42.4882C13.1827 42.164 13.4041 41.8653 13.6528 41.5891C13.9015 41.3144 14.1715 41.0683 14.4649 40.8521C14.7563 40.636 15.0652 40.4544 15.3897 40.3043C15.7141 40.1557 16.0483 40.0431 16.3941 39.9681C16.738 39.8915 17.0858 39.854 17.4374 39.854C17.7891 39.854 18.1368 39.8915 18.4807 39.9681C18.8265 40.0431 19.1607 40.1557 19.4851 40.3043C19.8096 40.4544 20.1185 40.636 20.4099 40.8521C20.7033 41.0683 20.9733 41.3144 21.222 41.5891C21.4707 41.8653 21.6921 42.164 21.8864 42.4882C22.0827 42.8109 22.2478 43.1531 22.3818 43.5119C22.5159 43.8721 22.6169 44.2428 22.6869 44.6241C22.7549 45.0053 22.7879 45.3911 22.7879 45.7798C22.7879 46.1701 22.7549 46.5543 22.6869 46.9371C22.6169 47.3183 22.5159 47.6891 22.3818 48.0478C22.2478 48.408 22.0827 48.7502 21.8864 49.0729C21.6921 49.3972 21.4707 49.6958 21.222 49.972C20.9733 50.2467 20.7033 50.4929 20.4099 50.709C20.1185 50.9251 19.8096 51.1068 19.4851 51.2569C19.1607 51.4054 18.8265 51.518 18.4807 51.5931C18.1368 51.6696 17.7891 51.7071 17.4374 51.7071Z",
    fill: "#3D1F1E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_16471_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 45,
    width: 10,
    height: 7
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6934 45.2285H21.9567V51.8089H12.6934V45.2285Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_16471_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0294 48.5173C22.0294 48.6789 21.9983 48.8391 21.94 48.9992C21.8798 49.1579 21.7924 49.3123 21.6758 49.4623C21.5593 49.6124 21.4174 49.7538 21.2484 49.8894C21.0794 50.0236 20.887 50.1491 20.6714 50.2631C20.4577 50.3785 20.2226 50.4809 19.97 50.5704C19.7175 50.6613 19.4513 50.7363 19.1696 50.7983C18.8879 50.8604 18.5984 50.908 18.3012 50.9397C18.002 50.9714 17.7008 50.9873 17.3978 50.9873C17.0927 50.9873 16.7916 50.9714 16.4944 50.9397C16.1952 50.908 15.9057 50.8604 15.624 50.7983C15.3442 50.7363 15.0761 50.6613 14.8235 50.5704C14.571 50.4809 14.3359 50.3785 14.1222 50.2631C13.9065 50.1491 13.7142 50.0236 13.5452 49.8894C13.3762 49.7538 13.2343 49.6124 13.1178 49.4623C13.0012 49.3123 12.9138 49.1579 12.8535 48.9992C12.7953 48.8391 12.7661 48.6789 12.7661 48.5173C12.7661 48.3543 12.7953 48.1942 12.8535 48.034C12.9138 47.8753 13.0012 47.7209 13.1178 47.5709C13.2343 47.4208 13.3762 47.2794 13.5452 47.1438C13.7142 47.0097 13.9065 46.8841 14.1222 46.7702C14.3359 46.6547 14.571 46.5523 14.8235 46.4629C15.0761 46.372 15.3442 46.2969 15.624 46.2349C15.9057 46.1729 16.1952 46.1252 16.4944 46.0935C16.7916 46.0618 17.0927 46.0459 17.3978 46.0459C17.7008 46.0459 18.002 46.0618 18.3012 46.0935C18.5984 46.1252 18.8879 46.1729 19.1696 46.2349C19.4513 46.2969 19.7175 46.372 19.97 46.4629C20.2226 46.5523 20.4577 46.6547 20.6714 46.7702C20.887 46.8841 21.0794 47.0097 21.2484 47.1438C21.4174 47.2794 21.5593 47.4208 21.6758 47.5709C21.7924 47.7209 21.8798 47.8753 21.94 48.034C21.9983 48.1942 22.0294 48.3543 22.0294 48.5173Z",
    fill: "#FA5B5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16471_521",
    x1: 8.57698,
    y1: 13.4321,
    x2: 8.57698,
    y2: 27.3571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16471_521",
    x1: 17.2143,
    y1: 0.102539,
    x2: 17.2143,
    y2: 19.7149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16471_521",
    x1: 26.2054,
    y1: 13.4321,
    x2: 26.2054,
    y2: 27.3571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16471_521",
    x1: 17.3839,
    y1: 21.2671,
    x2: 17.3839,
    y2: 59.7354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#FFDE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19F10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16471_521",
    x1: 6.71924,
    y1: 23.8745,
    x2: 11.3743,
    y2: 25.3741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#FFDE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19F10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_16471_521",
    x1: 6.71924,
    y1: 23.8745,
    x2: 11.3743,
    y2: 25.3741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#FFDE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19F10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_16471_521",
    x1: 24.9028,
    y1: 23.8745,
    x2: 29.5579,
    y2: 25.3741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#FFDE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19F10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_16471_521",
    x1: 24.9028,
    y1: 23.8745,
    x2: 29.5579,
    y2: 25.3741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#FFDE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19F10"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPikko);
export default __webpack_public_path__ + "static/media/pikko.d841565f887e1e92e1423a7dbe52f1f8.svg";
export { ForwardRef as ReactComponent };